import { render } from "./AbstractEventParticipationSlot.vue?vue&type=template&id=1de67478&ts=true"
import script from "./AbstractEventParticipationSlot.vue?vue&type=script&lang=ts"
export * from "./AbstractEventParticipationSlot.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__